/**
 * Типы документов карточки Wildberries.
 *
 * Копия `WB_DOCUMENT_TYPES` из `project/src/services/wb/wbDocuments.ts`:
 * фронт не может импортировать из `project/`, синхронизировать вручную
 * (источник — components/schemas/documentsRequest в спеке WB `02-items.yaml`).
 * Тип `6` в спеке отсутствует — нумерация идёт с пропуском.
 */
export const WB_DOCUMENT_TYPES: { value: string; label: string }[] = [
  { value: "1", label: "Сертификат соответствия" },
  { value: "2", label: "Декларация о соответствии" },
  { value: "3", label: "Свидетельство о государственной регистрации (СГР)" },
  {
    value: "4",
    label: "Регистрационное удостоверение (РУ) на медицинские изделия",
  },
  { value: "5", label: "Регистрационное удостоверение Республики Беларусь" },
  { value: "7", label: "Данные о регистрации пестицида" },
  { value: "8", label: "Данные о регистрации агрохимиката" },
  {
    value: "9",
    label: "Регистрационное удостоверение (РУ) на лекарственные препараты",
  },
]

/** Поля документа, которые маппятся на колонки Excel */
export const DOC_FIELDS = [
  "number",
  "productNumber",
  "tradeName",
  "applicant",
  "startDate",
  "endDate",
] as const

export type DocField = typeof DOC_FIELDS[number]

/** Поля-даты (обрабатываются через formatExcelDate) */
export const DOC_DATE_FIELDS: readonly DocField[] = ["startDate", "endDate"]
